import * as React from "react";
import type { SVGProps } from "react";
const SvgAlertTriangleSolidIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="alert_triangle_solid_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M461.227 115.499a57.77 57.77 0 0 1 101.546 0l410.624 732.586c22.571 40.278-5.632 90.582-50.773 90.582H101.376c-45.141 0-73.344-50.304-50.773-90.539l410.666-732.587zm8.106 695.168A42.667 42.667 0 0 0 512 853.333h.427a42.667 42.667 0 1 0 0-85.333H512a42.667 42.667 0 0 0-42.667 42.667zM554.667 384a42.667 42.667 0 1 0-85.334 0v256a42.667 42.667 0 1 0 85.334 0V384z"
    />
  </svg>
);
export default SvgAlertTriangleSolidIcon;
